import App from "../../services/App/App.js";
import ModelBody from "./HpadModel_Body.js";
import ModelDetails from "./HpadModel_Details.js";
import ModelNew from "./HpadModel_New.js";
import WarehouseModel from "../Warehouse/WhsModel.js";

export default {
  // required in model
  Module: ModelBody.Module,
  ModuleType: ModelBody.ModuleType,
  
  /*** related ***/

  HppAdjItem: ModelBody.HppAdjItem,

  /*** property ***/

  Access: ModelBody.Access,
  Search: ModelBody.Search,

  /*** method ***/

  createDetails() {
    return ModelBody.createDetails();
  },
  createItem() {
    return ModelBody.createItem();
  },

  setItemErrors(item, field, errors) {
    item.Errors = App.Vee.getRowErrors(item, field, errors);
  },

  updateItem(item) {
    ModelBody.updateItem(item);
  },
  updateItemByPackaging(item) {
    ModelBody.updateItemByPackaging(item);
  },
  updateItemReadOnly(userItem) {
    ModelBody.updateItemReadOnly(userItem);
  },

  validateItems(userItems, row) {
    return ModelBody.validateItems(userItems, row);
  },

  populateData(data, items) {
    let result = ModelBody.populateDetails(data);
    result.Items = ModelBody.populateItems(items);
    return result;
  },

  /*** method - Details ***/

  Details: {
    getActions(id, access) {
      return App.Access.getDetailsAvailableActions(
        id, ModelBody.Actions.Details, ModelBody.Module, access
      );
    },
    getItemInfo(item) {
      return ModelDetails.getItemInfo(item);
    }  
  },

  /*** method - List ***/

  List: {
    getActions(row, access) {
      return App.Access.getDetailsAvailableActions(
        row.ID, ModelBody.Actions.List, ModelBody.Module, access
      );
    },
    hasAccessAction(access) {
      return access.Act_Details ||
        access.Act_PrintDetails;
    }
  },

  /*** method - New ***/

  New:{
    getItemInfo(item) {
      return ModelNew.getItemInfo(item);
    },
    
    setDetailsByWarehouseList(userData, warehouseList) {
      ModelNew.setDetailsByWarehouseList(userData, warehouseList);
    },
    setItemByStock(item, stockData) {
      ModelNew.setItemByStock(item, stockData);
    }
  },

  /*** external ***/

  getWarehouseOptions(warehouseList, optionAllText) {
    return WarehouseModel.createOptions(warehouseList, optionAllText);
  },
  getWarehouseDefault(warehouseList, defaultId) {
    return WarehouseModel.getDefault(warehouseList, defaultId);
  }
}